<template>
    <div class='my-collapse' :class="{open:open}">
        <div @click="open=!open" class="collapse-header d-flex align-items-center">
           
           <div v-if='arrow'>
            <ico v-if="open==false" class='gray f4' icon="angle-right"></ico> 
            <ico v-if="open==true" class='gray f4' icon="angle-down"></ico> 
           </div>
           
            <slot name="header" ></slot>
           
            <slot v-if="open == true" name="header-open" ></slot>
            <slot v-if="open == false" name="header-close" ></slot>
            {{header}}
        </div>
        <div @click="open=!open" >
            <slot  v-if="open==false" name="body-on-close" ></slot>
        </div>
        <div class='collapse-body mt-1' >
            <slot></slot>
        </div>
    
    </div>
</template>

<script>
export default {
    data(){
        return {
            open:false
        }
    },
    props:{
        showOpen:{
            type:Boolean,
            default:false
        },
        header:{
            type:String,
            default:""
        },
        arrow:{
            default:false
        }
    },
    // watch:{
    //     open:function(val){
    //         this._open = val
    //     }
    // },

    created:function(){
        this.open = this.showOpen
        // this._open = this.open;
    }

}
</script>

<style lang="stylus" scoped>
    .my-collapse{
        & > .collapse-header{
            cursor:pointer;
            user-select: none;
        }
        & > .collapse-body{
            height:0;
            overflow hidden;
            transition: height 800ms;
        }
    }
    .my-collapse.open > .collapse-body{
            height auto;
            transition: height 800ms;
            //  overflow initial;
     }

</style>
